import { motion, AnimatePresence } from "framer-motion";
import { memo, useMemo } from "react";
import Separator from "../../../../../core/components/Separator.tsx";
import { RelatorioKm } from "../../../../../services/ModuloGerenciador/Motorista.ts";
import { useWindowWidth } from "../../../../../hooks/useWindowWidth.ts";
import RenderCsvLink, {
	ClasseCsv,
} from "../../../../../core/components/RenderCsvLink.tsx";

function TheadClassificacaoPontos({
	isProprietario = false,
}: {
	isProprietario?: boolean;
}) {
	const width = useWindowWidth();
	return (
		<thead>
			<tr>
				<th>{width > 950 && width < 1300 ? "Class." : "Classificação"}</th>
				<th>Nome</th>
				{isProprietario && <th>Placa</th>}
				<th>Documento</th>
				<th>Km Feitos</th>
				<th>{width > 950 && width < 1300 ? "Viagens" : "Viagens Feitas"}</th>
				<th>Pontos</th>
			</tr>
		</thead>
	);
}

function TabelaClassificacaoPontos({
	dados,
	title,
	classificacaoPontosList = [],
}: {
	dados: RelatorioKm[];
	title: "Motorista" | "Proprietário";
	classificacaoPontosList?: RelatorioKm[];
}) {
	const isProprietario = useMemo(() => title === "Proprietário", [title]);
	return (
		<motion.div
			layout
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.2 }}
			className="tabela-classificacao-container"
		>
			<div className="tabela-classificacao">
				<div className="tabela-classificacao-header">
					<h2>{title}</h2>
					<Separator size="lg" direction="horizontal" />
					<RenderCsvLink
						classe={
							title === "Motorista"
								? ClasseCsv.idClassificacaoPontosMotorista
								: ClasseCsv.idClassificacaoPontosProprietario
						}
						lista={classificacaoPontosList}
					/>
				</div>
				<div>
					<Separator size="lg" />
				</div>
				<motion.div
					layout="size"
					key="tabela-classificacao-wrapper"
					className="tabela-classificacao-wrapper"
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.2 }}
					style={{
						maxWidth: dados.length > 0 ? "100%" : "350px",
						width: "100%",
					}}
				>
					<AnimatePresence mode="wait">
						{dados.length > 0 ? (
							<table>
								<TheadClassificacaoPontos isProprietario={isProprietario} />
								<tbody>
									{dados.map((dado, index) => {
										return (
											<tr key={dado.nome + dado.documento + title + index}>
												<td>{dado.classificacao}</td>
												<td>
													{dado.nome.length > 12
														? `${dado.nome.slice(0, 12)}.`
														: dado.nome}
												</td>
												{isProprietario && <td>{dado.placa}</td>}
												<td>{dado.documento}</td>
												<td>{dado.kmFeitos}</td>
												<td>{dado.viagensFeitas}</td>
												<td>{dado.pontos}</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						) : (
							<motion.div
								key="no-data"
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
								transition={{ duration: 0.2 }}
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									justifyContent: "center",
									height: "100%",
									maxWidth: "350px",
									width: "100%",
									padding: "24px",
								}}
							>
								<p>
									Nenhum {isProprietario ? "proprietário" : "motorista"}{" "}
									encontrado.
								</p>
							</motion.div>
						)}
					</AnimatePresence>
				</motion.div>
				<div>
					<Separator size="lg" />
				</div>
			</div>
		</motion.div>
	);
}

export default memo(TabelaClassificacaoPontos);
